import React, { useState } from 'react';
import { message } from 'antd';

const EditVehicleModal = ({ vehicle, onClose, onSubmit, getCoordinates }) => {
  const [formData, setFormData] = useState({
    id: vehicle.id,
    name: vehicle.name,
    type: vehicle.type,
    driver: vehicle.driver,
    capacity: vehicle.capacity,
    location: vehicle.location,
    latitude: vehicle.coords[1],
    longitude: vehicle.coords[0]
  });
  const [isGeocoding, setIsGeocoding] = useState(false);

  const handleLocationBlur = async () => {
    if (!formData.location) return;
    setIsGeocoding(true);
    const coords = await getCoordinates(formData.location, () => {});
    if (coords) {
      setFormData(prev => ({ ...prev, latitude: coords.latitude, longitude: coords.longitude }));
    }
    setIsGeocoding(false);
  };

  const handleTypeChange = (e) => {
    const type = e.target.value;
    const capacityMap = { bike: 100, car: 300, truck: 500, van: 400 };
    setFormData(prev => ({ ...prev, type, capacity: capacityMap[type] ?? 300 }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.latitude || !formData.longitude) {
      message.warning("Please enter a valid location and wait for coordinates to auto-fill.");
      return;
    }
    onSubmit(formData);
  };

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{ display: 'block', position: 'fixed', zIndex: 1000, left: 0, top: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)' }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', margin: '5% auto', padding: '30px', borderRadius: '12px', width: '90%', maxWidth: '500px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #f3f4f6' }}>
          <h3 style={{ fontSize: '20px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Edit Vehicle</h3>
          <span onClick={onClose} style={{ color: '#9ca3af', fontSize: '28px', fontWeight: 'bold', cursor: 'pointer' }}>&times;</span>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Vehicle Number</label>
            <input type="text" required value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder="e.g., GJ-01-AB-1234"
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Vehicle Type</label>
            <select value={formData.type} onChange={handleTypeChange}
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }}>
              <option value="bike">Bike</option>
              <option value="car">Car</option>
              <option value="truck">Truck</option>
              <option value="van">Van</option>
            </select>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Driver Name</label>
            <input type="text" required value={formData.driver} onChange={e => setFormData({ ...formData, driver: e.target.value })} placeholder="e.g., Ramesh Kumar"
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Capacity (kg)</label>
            <input type="number" required min="10" value={formData.capacity} onChange={e => setFormData({ ...formData, capacity: e.target.value })}
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>
              Location
              <span style={{ fontSize: '12px', color: '#9ca3af', marginLeft: '5px' }}>(e.g., "Privilon Building, Iscon Cross Road, Ahmedabad")</span>
            </label>
            <input type="text" required value={formData.location} onChange={e => setFormData({ ...formData, location: e.target.value })}
              onBlur={handleLocationBlur} placeholder="Building, Street, City"
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px' }} />
            {isGeocoding && (
              <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#667eea' }}>
                <div className="spinner" style={{ width: '14px', height: '14px', border: '2px solid rgba(0,0,0,0.1)', borderTopColor: '#667eea', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                Fetching coordinates...
              </div>
            )}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Latitude</label>
              <input type="text" readOnly value={formData.latitude} placeholder="Auto-filled"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#f3f4f6' }} />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 500, color: '#374151' }}>Longitude</label>
              <input type="text" readOnly value={formData.longitude} placeholder="Auto-filled"
                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', background: '#f3f4f6' }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button type="submit" disabled={!formData.latitude || !formData.longitude} style={{
              flex: 1, padding: '12px', background: (!formData.latitude || !formData.longitude) ? '#9ca3af' : '#667eea', color: 'white', border: 'none', borderRadius: '8px',
              cursor: (!formData.latitude || !formData.longitude) ? 'not-allowed' : 'pointer', fontSize: '14px', fontWeight: 500
            }}>Update Vehicle</button>
            <button type="button" onClick={onClose} style={{ padding: '12px 20px', background: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 500 }}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditVehicleModal;
